import { Box, Button, Group, Stack, Text, Title, type ButtonProps } from "@mantine/core";
import { IconArrowRight, IconExternalLink } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { accountsLink, type CtaPlacement } from "../lib/track";

export const ACCOUNT_CTA = "Create your Passio account";

/** The primary "sign up for real" button. */
export function AccountButton({ placement, children = ACCOUNT_CTA, ...props }: { placement: CtaPlacement; children?: ReactNode } & ButtonProps) {
  return (
    <Button component="a" {...accountsLink(placement)} color="lime" c="ink.8" rightSection={<IconExternalLink size={16} />} {...props}>
      {children}
    </Button>
  );
}

/** Boxed call-out: a headline, one line of copy and the account button. */
export function AccountCallout({
  placement,
  title = "Ready to build with Passio?",
  body = "Create your Passio account to get your own API key, pick a plan and ship this in your app.",
  dark = false,
}: {
  placement: CtaPlacement;
  title?: string;
  body?: ReactNode;
  dark?: boolean;
}) {
  return (
    <Box
      className={dark ? "pd-dark" : undefined}
      p={{ base: "md", sm: "lg" }}
      style={{ borderRadius: 14, border: `1px solid ${dark ? "var(--pd-ink-border)" : "var(--pd-lime)"}`, background: dark ? undefined : "#f3fbe9" }}
    >
      <Group justify="space-between" gap="md" wrap="wrap">
        <Stack gap={4} maw={640}>
          <Title order={3} fz={20} c={dark ? "white" : undefined}>
            {title}
          </Title>
          <Text fz="sm" className={dark ? "pd-dim" : undefined} c={dark ? undefined : "dimmed"}>
            {body}
          </Text>
        </Stack>
        <AccountButton placement={placement} size="md" rightSection={<IconArrowRight size={16} />} />
      </Group>
    </Box>
  );
}
